import { select, selection, event, dispatch, quadtree, timer } from 'd3';
import * as _ from 'lodash';

function directive($window, timeFormat, $state, $stateParams) {
    return  {
        transclude: true,
        require: '^lateralmap',
        // template: '<svg id="lateral_map"></svg>',
        template: require('./lateral_map_view.html'),
        link: function ($scope, element, attrs, lmCtrl) {
            /////////////////
            /// VARIABLES ///
            ///////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
                // nodes_object get turned into this array (shows all the visible nodes) (d3 needs an array for it can  .data(x).enter())
                let visible_nodes: Node[], visible_links: Link[];

                // FORCE CHART
                let load_complete = 0; // if = 2, inital load is complete (2 different table calls)
                let new_lat_nodes = false; // whenever a new nodes affects the nodes_object from network assets table, it is then set to true so it can call redraw()
                let new_lat_conns = false; // whenever a new nodes affects the nodes_object from lateral connections, it is then set to true so it can call redraw()

                let distanceMin = 1,
                distanceMax = Infinity;

                let text_padding = 4; // padding about the hover text

                // Scale for the map (zoom and movements)
                let scale = 1;
                let translate = [0,0];

                if (lmCtrl.settings.get('translateX')) {
                    translate[0] = lmCtrl.settings.get('translateX')
                }
                if (lmCtrl.settings.get('translateY')) {
                    translate[1] = lmCtrl.settings.get('translateY')
                }
                if (lmCtrl.settings.get('scale')) {
                    scale = lmCtrl.settings.get('scale')
                }
                // used for sorting the sidear node info (what columns and direction)
                let temp_sort = "weight";
                let desc = true;

            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
            ////////////////////////////
            /// CUSTOM FORCE CLASSES ///
            //////////////////////////// -------------------------------------------------------------------------------------------------------------------------------------------------
                /*
                    - This is the d3_force_chart ripped out, modified and put into a class.
                    - So what happens is that you have 2 set of arrays, one is the array of nodes, the other is array of links between the nodes.
                    - Each node is an object, there is a seperate Object of objects mapped by IPs for easy access and pass by reference
                    - The links array are objects that have the source Ip and target IP.
                    - On force.start, the target IP and source IP is replaced by the actual node object (with the matching IP) from nodes_object (links.source = nodes_object[links.source] (if links.source = IP))
                    - Once start is called, it calls resume, which changes the alpha value. Inside force.tick it will gradualy lower alpha until it reachs the specified alpha value which while simultaneously adjusting the node
                        and link positions (until the alpha has reached its limit) which stops the graph from drawing.
                */

                class CustomForce {
                    canvas: any; //HTMLCanvasElement (adds 2 "errors")
                    ctx: CanvasRenderingContext2D;
                    node: Node;
                    nodes: Node[];
                    links: Link[];
                    valid: boolean;
                    dragging: boolean;
                    canvas_clicked: boolean;
                    selection: Node;
                    offsetX: number;
                    offsetY: number;
                    scale: number;
                    originx: number;
                    originy: number;
                    xi: number;
                    yi: number;
                    event: any;
                    timer;
                    size: number[];
                    alpha: number;
                    chargeDistance: number;
                    theta: number;

                    constructor (id: string) {
                        this.canvas = document.getElementById(id);
                        this.canvas.height = lmCtrl.height;
                        this.canvas.width = lmCtrl.width;
                        this.ctx = this.canvas.getContext("2d");
                        this.nodes = [];
                        this.links = [];;
                        // this.ctx = canvas.getContext('2d');
                        this.valid = false; // when set to false, the canvas will redraw everything
                        this.dragging = false; // Keep track of when we are dragging a node
                        this.canvas_clicked = false; // Keep track of when we are dragging the canvas
                        // the current selected object. In the future we could turn this into an array for multiple selection
                        this.selection = null;
                        this.offsetX = 0;
                        this.offsetY = 0;

                        this.scale = 1;
                        this.originx = 0;
                        this.originy = 0;
                        this.resize_zoom();

                        this.event = dispatch("start", "tick", "end"),
                        this.timer = null;
                        this.size = [1,1];
                        this.alpha = null;
                        this.chargeDistance = Infinity;
                        this.theta = 0.64;
                        // d3.rebind(this, this.event, "on");
                        // this.event.on("start", this.start);
                        // this.event.on("tick", this.tick);
                        // this.event.on("end", this.end);

                        //fixes a problem where double clicking causes text to get selected on the canvas
                        this.canvas.addEventListener('selectstart', (e) => { e.preventDefault(); return false; }, false);
                        // Up, down, and move are for dragging
                        this.canvas.addEventListener('mousedown', (e) => {
                            this.mousedown(e);
                        }, true);
                        this.canvas.addEventListener('mousemove', (e) => {
                            this.mousemove(e);
                        }, true);
                        this.canvas.addEventListener('mousewheel', (e) => {
                            this.mousewheel(e);
                        }, true);
                        this.canvas.addEventListener('mouseup', (e) => {
                            this.mouseup(e);
                        }, true);
                        this.canvas.addEventListener('dblclick', (e) => {
                            this.dblclick(e);
                        }, true);
                    }
                    // nodes/links positioning & movement
                        // makes sure all the nodes have a weight
                        // also makes sure that all the links have actual nodes attached at each end
                        // calls this.resume() which stats the movements of the nodes
                        start(){
                            let current_index: number, nodes_length = this.nodes.length, links_length = this.links.length;
                            let width = this.size[0], height = this.size[1];
                            for (current_index = 0; current_index < nodes_length; ++current_index) {
                                this.nodes[current_index].index = current_index;
                                this.nodes[current_index].weight = 0;
                            }
                            for (current_index = 0; current_index < links_length; ++current_index) {
                                // if (typeof this.links[current_index].source == "string") {
                                //     this.links[current_index].setSource(lmCtrl.nodes_object[this.links[current_index].source]);
                                // }
                                // if (typeof this.links[current_index].target == "string") {
                                //     this.links[current_index].setTarget(lmCtrl.nodes_object[this.links[current_index].target]);
                                // }
                                ++this.links[current_index].source.weight;
                                ++this.links[current_index].target.weight;
                            }
                            return this.resume();
                        }
                        // this is the function that makes the nodes and links move and stops the chart from moving once the alpha reachs its limit
                        // it also perferms certain operations depending on the force chart attributes (gravity, charge, etc) can calls draw which draws all the nodes and links
                        tick () {
                            if ((this.alpha *= 0.99) < 0.009) { // 0.009
                                // this.valid = true;
                                if (this.timer) {
                                    this.timer.stop();
                                }
                                this.timer = null;
                                this.event.call("end", {type: "end"},  this.alpha = 0);
                                return true;
                            }
                            if (!this.dragging) {
                                let nodes_length = this.nodes.length, links_length = this.links.length;
                                let qt, current_index: number, current_link: Link , current_node: Node, current_source:Node, current_target:Node, current_distance: number, current_force: number, x_distance: number, y_distance: number;
                                // gauss-seidel relaxation for links
                                for (current_index = 0; current_index < links_length; ++current_index) {
                                    current_link = this.links[current_index];
                                    current_source = current_link.source;
                                    current_target = current_link.target;
                                    x_distance = current_target.x - current_source.x;
                                    y_distance = current_target.y - current_source.y;
                                    if (current_distance = (x_distance * x_distance + y_distance * y_distance)) {
                                        current_distance = this.alpha * lmCtrl.link_strength * ((current_distance = Math.sqrt(current_distance)) - lmCtrl.link_distance) / current_distance;
                                        x_distance *= current_distance;
                                        y_distance *= current_distance;
                                        current_target.x -= x_distance * (current_force = (current_source.weight + current_target.weight ? current_source.weight / (current_source.weight + current_target.weight) : 0.5));
                                        current_target.y -= y_distance * current_force;
                                        current_source.x += x_distance * (current_force = 1 - current_force);
                                        current_source.y += y_distance * current_force;
                                    }
                                }

                                // apply gravity forces
                                if (current_force = this.alpha * lmCtrl.gravity) {
                                    x_distance = this.size[0] / 2;
                                    y_distance = this.size[1] / 2;
                                    current_index = -1;
                                    if (current_force) while (++current_index < nodes_length) {
                                        current_node = this.nodes[current_index];
                                        current_node.x += (x_distance - current_node.x) * current_force;
                                        current_node.y += (y_distance - current_node.y) * current_force;
                                    }
                                }

                                // compute quadtree center of mass and apply charge forces
                                if (lmCtrl.charge) {
                                    var i, n = this.nodes.length, node, tree;
                                    tree = quadtree(this.nodes, doX, doY).visitAfter(this.forceAccumulate);
                                    for (i = 0; i < n; ++i) {
                                        this.node = this.nodes[i];
                                        if (!this.node.fixed) {
                                            tree.visit((quad, x0, y0, x1, y1) => {
                                                this.repulse(quad, x0, _, x1)
                                                this.xi = this.node.x + this.node.px;
                                                this.yi = this.node.y + this.node.py;
                                                this.collide(quad, x0, y0, x1, y1)
                                            });
                                        }
                                    }
                                }

                                // position verlet integration
                                current_index = -1;
                                while (++current_index < nodes_length) {
                                    current_node = this.nodes[current_index];
                                    if (current_node.fixed) {
                                        current_node.x = current_node.px;
                                        current_node.y = current_node.py;
                                    } else {
                                        current_node.x -= (current_node.px - (current_node.px = current_node.x)) * lmCtrl.friction;
                                        current_node.y -= (current_node.py - (current_node.py = current_node.y)) * lmCtrl.friction;
                                    }
                                }
                            }
                            this.draw();
                            this.event.call("tick", {type: "tick"},  this.alpha);
                        }
                        forceAccumulate(quad, alpha: number) { // this is used with charge
                            var strength = 0, q, c, x, y, i;
                            
                            // For internal nodes, accumulate forces from child quadrants.
                            if (quad.length) {
                                for (x = y = i = 0; i < 4; ++i) {
                                    if ((q = quad[i]) && (c = q.value)) {
                                        strength += c, x += c * q.x, y += c * q.y;
                                    }
                                }
                                quad.x = x / strength;
                                quad.y = y / strength;
                            }

                            // For leaf nodes, accumulate forces from coincident quadrants.
                            else {
                                q = quad;
                                q.x = q.data.x;
                                q.y = q.data.y;
                                do strength += 1;
                                while (q = q.next);
                            }

                            quad.value = strength;
                        }

                        // if there is charge, repulse is used
                        // this function is basically the opposite of gravity, all the nodes want to gravitate towards the middle, this will make sure they spread out a bit.
                        // repulse(node: Node) {
                        repulse(quad, x1, _, x2) {
                            var x = quad.x - this.node.x,
                                y = quad.y - this.node.y,
                                w = x2 - x1,
                                l = x * x + y * y,
                                k = this.alpha * lmCtrl.charge;
                            // Apply the Barnes-Hut approximation if possible.
                            // Limit forces for very close nodes; randomize direction if coincident.
                            if (w * w / this.theta < l) {
                                if (l < distanceMax) {
                                    if (x === 0) x = (Math.random() - 0.5), l += x * x;
                                    if (y === 0) y = (Math.random() - 0.5), l += y * y;
                                    if (l < distanceMin) l = Math.sqrt(l);
                                    // if (l > k) {
                                    if (((x * k / l) < 3) || ((x * k / l) > -3)){
                                        this.node.px -= x * k / l;
                                        this.node.py -= y * k / l;
                                    }
                                    // }
                                }
                                return true;
                            } else if (quad.length || l >= distanceMax) return;

                            // Limit forces for very close nodes; randomize direction if coincident.
                            if (quad.data !== this.node || quad.next) {
                                if (x === 0) x = (Math.random() - 0.5), l += x * x;
                                if (y === 0) y = (Math.random() - 0.5), l += y * y;
                                if (l < distanceMin) l = Math.sqrt(l);
                            }

                            do if (quad.data !== this.node) {
                                // if ((l > k) && (l > Math.abs(lmCtrl.charge)*2)) {
                                if (((x * k / l) < 3) || ((x * k / l) > -3)){
                                    this.node.px -= x * k / l;
                                    this.node.py -= y * k / l;
                                }
                                // }
                            } while (quad = quad.next);
                        } 
                        collide(quad, x0, y0, x1, y1) {
                            var data = quad.data, 
                            rj = lmCtrl.maxRadius, 
                            r = (lmCtrl.maxRadius*lmCtrl.padding) + lmCtrl.maxRadius;
                            if (data) {
                                if (data.ip !== this.node.ip) {
                                    r = data.radius + lmCtrl.maxRadius + (lmCtrl.maxRadius*lmCtrl.padding);
                                    rj = data.radius;
                                    var x = this.xi - data.x - data.px,
                                        y = this.yi - data.y - data.py,
                                        l = x * x + y * y;
                                    if (l < r * r) {
                                        if (x === 0) x = (Math.random() - 0.5), l += x * x;
                                        if (y === 0) y = (Math.random() - 0.5), l += y * y;
                                        l = (r - (l = Math.sqrt(l))) / l * this.alpha;
                                        this.node.px -= (x *= l) * (r = (rj *= rj) / ((lmCtrl.maxRadius*lmCtrl.maxRadius) + rj));
                                        this.node.py -= (y *= l) * r;
                                        if (!data.fixed) {
                                        	data.px += x * (r = 1 - r);
                                            data.py += y * r;
                                        }
                                    }
                                }
                                return;
                            }
                            return x0 > this.xi + r || x1 < this.xi - r || y0 > this.yi + r || y1 < this.yi - r;
                        }
                        // starts the movement of the map
                        resume () {
                            return this.set_alpha(0.1);
                        }
                        // stops the movement of the map
                        stop () {
                            return this.set_alpha(0);
                        }
                    // editing values for custom force chart
                        set_nodes (x: Node[]) {
                            if (!arguments.length) return this.nodes;
                            this.nodes = x;
                            this.valid = false;
                        }
                        set_links (x: Link[]) {
                            if (!arguments.length) return this.links;
                            this.links = x;
                            this.valid = false;
                        }
                        set_size (x: number[]) {
                            if (!arguments.length) return this.size;
                            this.size = x;
                        }
                        set_theta (x: number) {
                            if (!arguments.length) return Math.sqrt(this.theta);
                            this.theta = x * x;
                        }
                        // starts the d3 timer, also is when alpha is greater than a cetain value (0.009) all the nodes move, else the map stops
                        set_alpha (x: number) { // But this will be the smoothness / speed of the node and link movements
                            if (!arguments.length) return this.alpha;
                            x = +x;
                            if (this.alpha) { // if we're already running
                                if (x > 0) { // we might keep it hot
                                    this.alpha = x;
                                } else { // or we might stop
                                    if (this.timer) {
                                        this.timer.stop();
                                    }
                                    this.timer = null;
                                    this.event.call("end", {type: "end"},  this.alpha = 0);
                                }
                            } else if (x > 0) { // otherwise, fire it up!
                                this.event.call("start", {type: "start"},  this.alpha = x);
                                this.timer = timer(this.tick.bind(this));
                            }
                        }
                    // canvas drawing
                        clear () {
                            this.ctx.clearRect(this.originx, this.originy, (lmCtrl.width/this.scale)*2, (lmCtrl.height/this.scale)*2);
                        }
                        draw () {
                            if (!this.valid) {
                                let ctx = this.ctx;
                                let nodes = this.nodes;
                                let links = this.links;
                                this.clear();
                                // this.set_zoom();
                                // this.ctx.fillStyle = "#999";
                                // this.ctx.fillRect(this.originx, this.originy, (lmCtrl.width/this.scale), (lmCtrl.height/this.scale))
                                // ** Add stuff you want drawn in the background all the time here **
                                // draw all nodes
                                let i: number, l = links.length;
                                for (i = 0; i < l; i++) {
                                    // this.valid = true;
                                    links[i].draw(ctx);
                                }
                                // ** Add stuff you want drawn in the background all the time here **
                                // draw all nodes
                                let x: number, n = nodes.length;
                                for (x = 0; x < n; x++) {
                                    let node = nodes[x];
                                    // We can skip the drawing of elements that have moved off the screen:
                                    // if (node.x - node.r > (lmCtrl.width/this.scale)
                                    //     || node.y - node.radius > (lmCtrl.height/this.scale)
                                    //     || node.x + node.radius < (0+this.originx)
                                    //     || node.y + node.radius < (0+this.originy)) continue;
                                    node.draw(ctx);
                                }
                                for (x = 0; x < n; x++) {
                                    if (nodes[x].hover) nodes[x].drawHover(ctx);
                                }
                                // ** Add stuff you want drawn on top all the time here **
                            }
                        }
                        // needs to be called on load and or when the window size changes
                        resize_zoom () {
                            // this.ctx.restore();
                            this.valid = false;
                            this.ctx.translate(0,0);
                            this.scale = scale;
                            this.originx = translate[0];
                            this.originy = translate[1];
                            this.ctx.scale(this.scale,this.scale);
                            this.ctx.translate(-this.originx,-this.originy);
                            // this.ctx.save();
                        }
                        // action from the sidebar
                        reset_zoom () {
                            this.valid = false;
                            this.ctx.translate(this.originx,this.originy);
                            scale = 1/scale;
                            translate = [0,0]
                            this.scale = scale;
                            this.originx = translate[0];
                            this.originy = translate[1];
                            this.ctx.scale(this.scale,this.scale);
                            this.ctx.translate(-this.originx,-this.originy);
                            this.scale = scale = 1;
                            this.draw();
                        }
                    // mouse events
                        // returns the mouse coordinates
                        getMouse (e) {
                            let element = this.canvas, offsetX = 0, offsetY = 0, mx: number, my: number;

                            // Compute the total offset
                            if (element.offsetParent !== undefined) {
                                do {
                                    offsetX += element.offsetLeft;
                                    offsetY += element.offsetTop;
                                } while ((element = element.offsetParent));
                            }

                            mx = e.pageX - offsetX
                            my = e.pageY - offsetY;

                            // We return a simple javascript object (a hash) with x and y defined
                            return {x: mx, y: my};
                        }
                        // all the things that happen when you click (mousedown) on the canvas:
                            // check to see if a node, link or nothing is clicked and depending;
                        mousedown (e) {
                            this.resume()
                            this.canvas_clicked = true;
                            let mouse = this.getMouse(e);
                            let mx: number = mouse.x;
                            let my: number = mouse.y;
                            let nodes = this.nodes;
                            let n = nodes.length;
                            let i: number;
                            let isNodeSelected = false;
                            let links = this.links;
                            let l = links.length;
                            let linkClicked = false;
                            let mySel: Node;
                            for (i = n-1; i >= 0; i--) {
                                if (nodes[i].contains(mx, my)) {
                                    mySel = nodes[i];
                                    isNodeSelected = mySel.selected;
                                    this.canvas_clicked = false;
                                    break;
                                }
                            }
                            for (i = l-1; i >= 0; i--) {
                                if (links[i].contains(mouse)) {
                                    linkClicked = true;
                                    this.canvas_clicked = false;
                                    break;
                                }
                            }
                            if (mySel) {
                                if (!lmCtrl.ctrlKey) {
                                    nodes.map((d:Node) => { d.selected = false;})
                                }
                                if (isNodeSelected) {
                                    mySel.selected = false;
                                } else {
                                    mySel.selected = true;
                                }
                                // Keep track of where in the object we clicked
                                // so we can move it smoothly (see mousemove)
                                this.offsetX = (mx/this.scale - mySel.x);
                                this.offsetY = (my/this.scale - mySel.y);
                                this.dragging = true;
                                this.selection = mySel;
                                this.valid = false;
                                lmCtrl.nodeClicked(mySel)
                                return;
                            }
                            // havent returned means we have failed to select anything.
                            // If there was an object selected, we deselect it
                            if (this.selection) {
                                this.selection = null;
                                this.valid = false; // Need to clear the old selection border
                            }
                            if (!linkClicked) {
                                $scope.unselect();
                            }
                        }
                        // this is constantly beingc called if your mouse is over the canvas,
                            // depending on your actions or mouse placement will affect what happens
                        mousemove (e) {
                            if (this.dragging){
                                e.target.style.cursor = 'move';
                                this.selection.selected = true;
                                this.set_alpha(0.1);
                                let mouse = this.getMouse(e);
                                // We don't want to drag the object by its top-left corner, we want to drag it
                                // from where we clicked. Thats why we saved the offset and use it here
                                this.selection.x = (mouse.x/this.scale - this.offsetX);
                                this.selection.y = (mouse.y/this.scale - this.offsetY);
                                this.valid = false; // Something's dragging so we must redraw
                            } else if (this.canvas_clicked) {
                                this.valid = false;
                                this.clear();
                                this.ctx.translate(this.originx,this.originy);

                                this.originx -= (e.movementX/this.scale);
                                this.originy -= (e.movementY/this.scale);

                                this.ctx.translate(-this.originx,-this.originy);

                                translate = [this.originx, this.originy];
                                this.draw();
                                lmCtrl.waitForFinalEvent(() => {
                                    zoom_chart_end();
                                }, 250, "lateral_map_zoom");
                            } else {
                                e.target.style.cursor = 'default';
                                let nodes = this.nodes;
                                let links = this.links;
                                nodes.map((d:Node) => { d.hover = false;})
                                links.map((d:Link) => { d.hover = false;})
                                let mouse = this.getMouse(e);
                                let n = nodes.length;
                                for (let i = n-1; i >= 0; i--) {
                                    if (nodes[i].contains(mouse.x, mouse.y)) {
                                        nodes[i].hover = true;
                                        e.target.style.cursor = 'pointer';
                                        this.draw();
                                        return;
                                    }
                                }
                                let l = links.length;
                                for (let i = l-1; i >= 0; i--) {
                                    if (links[i].contains(mouse)) {
                                        links[i].hover = true;
                                        this.draw();
                                        return;
                                    }
                                }
                            }
                            this.draw();
                        }
                        // when you release the mouse click
                        mouseup (e) {
                            e.target.style.cursor = 'default';
                            if (this.selection) {
                                this.selection.fixed = true;
                                this.selection.px = this.selection.x;
                                this.selection.py = this.selection.y;
                            }
                            this.dragging = false;
                            this.canvas_clicked = false;
                        }
                        // zooming of the canvas with your mouse wheel
                        mousewheel (e) {
                            e.preventDefault();
                            var mousex = e.clientX - this.canvas.offsetLeft;
                            var mousey = e.clientY - this.canvas.offsetTop;
                            var wheel = e.wheelDelta/120;//n or -n

                            var zoom = 1 + wheel/4;
                            if ((this.scale*zoom > 0.25) && (this.scale*zoom < 3)) {
                                this.valid = false;
                                this.clear();
                                this.ctx.translate(this.originx,this.originy);
                                this.ctx.scale(zoom,zoom);
                                this.originx = ( mousex / this.scale + this.originx - mousex / ( this.scale * zoom ) );
                                this.originy = ( mousey / this.scale + this.originy - mousey / ( this.scale * zoom ) );
                                this.ctx.translate(-this.originx,-this.originy);
                                this.scale *= zoom;
                                translate = [this.originx, this.originy];
                                scale = this.scale;
                                this.draw();
                                lmCtrl.waitForFinalEvent(() => {
                                    zoom_chart_end();
                                }, 250, "lateral_map_zoom");
                            }
                        }
                        // action that happens when you double click on the canvas
                        dblclick (e) {
                            e.preventDefault();
                            let mouse = this.getMouse(e);
                            let nodes = this.nodes;
                            let l = nodes.length;
                            for (let i = l-1; i >= 0; i--) {
                                if (nodes[i].contains(mouse.x, mouse.y)) {
                                    nodes[i].fixed = false;
                                    nodes[i].selected = false;
                                    this.selection = null;
                                    if (nodes[i].collapse) {
                                        lmCtrl.expand_collapsed(nodes[i])
                                    }
                                    return;
                                }
                            }
                        }
                }

                function doX (d) {
                    return d.x
                }
                function doY (d) {
                    return d.y
                }

                // Node class contains:
                    // Node attributes
                    // drawing on canvas
                    // drawing of hover on nodes
                class Node {
                    id: any = false; // (boolean | string) = false
                    ip: any = ""; // (string | string[]) = "";
                    hostname: any = "N/A"; // (string | string[]) = "N/A";
                    mac: (string | string[]) = "N/A"; //  (string | string[]) = "N/A"
                    os: (string | string[]) = "N/A"; // (string | string[]) = "N/A"
                    type: any = "new"; // (string | string[] | boolean) = "N/A"
                    vendor: (string | string[]) = "N/A"; // (string | string[]) = "N/A";
                    group: any = "N/A"; // (string | number | string[]) = "N/A";
                    collapse: boolean = false;
                    action: (boolean | string) = false; //
                    resp_l7: string[] = [];
                    orig_l7: string[] = [];
                    ioc: number = 0;
                    weight: number = 0;
                    index: number = 0;
                    first_seen: number = 0;
                    last_seen: number = 0;
                    selected: boolean = false;
                    hover: boolean = false;
                    fixed: boolean = false;
                    grey: boolean = false;
                    visible: boolean = true;
                    radius: number = lmCtrl.maxRadius;
                    x: number = (lmCtrl.width / 2)+(Math.random()*lmCtrl.maxRadius);
                    y: number = (lmCtrl.height / 2)+(Math.random()*lmCtrl.maxRadius);
                    px: number = this.x;
                    py: number = this.y;

                    constructor (node : Object) {
                        if (node) {
                            this.editNode(node)
                        }
                    }
                    editNode (node : Object) {
                        let n: string;
                        for (n in node) {
                            if ((n === "ioc_severity") || (n === "ioc")) {
                                this["ioc"] = Math.max(this.ioc,node[n]);
                            } else {
                                this[n] = node[n];
                            }
                        }
                    }
                    returnObject() {
                        return {
                            id: this.id,
                            ip: this.ip,
                            hostname: this.hostname,
                            mac: this.mac,
                            os: this.os,
                            type: this.type,
                            vendor: this.vendor,
                            group:this.group,
                            collapse: this.collapse,
                            action: this.action,
                            resp_l7: this.resp_l7,
                            orig_l7: this.orig_l7,
                            ioc: this.ioc,
                            weight: this.weight,
                            first_seen: this.first_seen,
                            last_seen: this.last_seen,
                            selected: this.selected,
                            hover: this.hover,
                            fixed: this.fixed,
                            grey: this.grey,
                            visible: this.visible,
                            radius: this.radius,
                            x: this.x,
                            y: this.y,
                            px: this.px,
                            py: this.py,
                        }
                    }
                    contains (mx: number, my: number) {
                        return ((this.x - this.radius) <= (mx/scale)+translate[0]) &&
                        ((this.x + this.radius) >= (mx/scale)+translate[0]) &&
                        ((this.y - this.radius) <= (my/scale)+translate[1]) &&
                        ((this.y + this.radius) >= (my/scale)+translate[1])
                    }
                    // draws the node on the canvas
                    draw (ctx) {
                        if (this.grey) {
                            ctx.globalAlpha=0.5;
                        } else {
                            ctx.globalAlpha=1;
                        }
                        ctx.save();
                        ctx.translate(this.x, this.y);
                        ctx.beginPath();
                        ctx.moveTo(0,0);
                        let icon = this.type;
                        let group = this.group;
                        if (this.collapse) {
                            icon = this.action;
                            group = "#333";
                            if (this.group.length === 1) group = this.group[0];
                            if (this.action === "ioc") group = this.ioc;
                        }
                        let isSel = 1;
                        let bigger = 0;
                        if (this.selected) {
                            isSel = 1.5;
                            bigger = 1;
                        }
                        ctx.fillStyle = lmCtrl.color(group);
                        ctx.arc(0, 0, this.radius*isSel, 0, 2 * Math.PI);
                        ctx.fill();
                        ctx.closePath();

                        ctx.fillStyle = "#fff";
                        ctx.translate(svg_translate(icon, bigger)[0], svg_translate(icon, bigger)[1]);
                        ctx.scale(svg_scale(icon, bigger), svg_scale(icon, bigger));
                        ctx.beginPath();
                        ctx.moveTo(0,0);
                        ctx.strokeStyle = "#fff";
                        let img = new Path2D(lmCtrl.svgType(icon))
                        ctx.stroke(img);
                        ctx.fill(img);
                        ctx.closePath();
                        ctx.restore();
                    }
                    // draws the hover rectangles of the nodes
                    drawHover (ctx) {
                        if (this.hover) {
                            if (this.grey) {
                                ctx.globalAlpha=0.5;
                            } else {
                                ctx.globalAlpha=1;
                            }
                            let isSel = 1;
                            if (this.selected) {
                                isSel = 1.5;
                            }
                            let temp_string = "";
                            if (this.collapse) {
                                temp_string = ((this.ip.length === 1) ? "1 Node" : this.ip.length + " Nodes");
                            } else {
                                if ($scope.display_ip === "true") {
                                    temp_string += this.ip
                                }
                                if ($scope.display_hostname) {
                                    if (($scope.display_ip === "true") && (this.hostname !== "N/A")) {
                                        temp_string+= " - "
                                    }
                                    temp_string += this.hostname.replace("N/A","");
                                }
                            }
                            ctx.save();
                            ctx.font = "12px Helvetica,sans-serif";
                            if (ctx.measureText(temp_string).width > 0) {
                                ctx.translate(this.x, this.y);
                                ctx.beginPath();
                                ctx.moveTo(0,0);
                                ctx.beginPath();
                                ctx.scale(1,1);
                                ctx.strokeStyle = "#ccc";
                                ctx.fillStyle = "#fff";
                                ctx.lineWidth = 2;
                                roundRect(ctx, (this.radius*isSel*1.6), -10, (ctx.measureText(temp_string).width + 12), 20, 6, true, true);
                                ctx.fillStyle = "#000";
                                ctx.fillText(temp_string, (this.radius*isSel*1.6)+6, 4);
                                ctx.closePath();
                            }
                            ctx.restore();
                        }
                    }
                }
                // function for creating rounded rectangles for the hover of nodes and links
                function roundRect(ctx, x: number, y: number, width: number, height: number, rdis: number, fill: boolean, stroke: boolean) {
                    if (typeof stroke == 'undefined') {
                        stroke = true;
                    }
                    if (typeof rdis === 'undefined') {
                        rdis = 5;
                    }
                    let radius = {tl: rdis, tr: rdis, br: rdis, bl: rdis};
                    ctx.beginPath();
                    ctx.moveTo(x + radius.tl, y);
                    ctx.lineTo(x + width - radius.tr, y);
                    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
                    ctx.lineTo(x + width, y + height - radius.br);
                    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
                    ctx.lineTo(x + radius.bl, y + height);
                    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
                    ctx.lineTo(x, y + radius.tl);
                    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
                    ctx.closePath();
                    if (fill) {
                        ctx.fill();
                    }
                    if (stroke) {
                        ctx.stroke();
                    }
                }
                // Link class contains a source and target which are both nodes
                class Link {
                    source: Node;
                    target: Node;
                    hover: boolean = false;
                    constructor (source: Node, target: Node) {
                        this.source = source;
                        this.target = target;
                    }
                    // draws the links
                    draw (ctx) {
                        if ((this.source.selected) || (this.target.selected)) {
                            ctx.globalAlpha = 1;
                        } else {
                            ctx.globalAlpha = 0.5;
                        }
                        ctx.save();
                        ctx.beginPath();
                        ctx.moveTo(this.source.x, this.source.y);
                        ctx.lineTo(this.target.x, this.target.y);
                        ctx.lineWidth = 1;
                        if (this.hover) {
                            this.source.hover = true;
                            this.target.hover = true;
                            ctx.lineWidth = 5;
                        }
                        if (this.source.ioc > 0 && this.target.ioc > 0) {
                            ctx.strokeStyle = lmCtrl.color(Math.max(this.source.ioc,this.target.ioc));
                        } else {
                            ctx.strokeStyle = "#aaa";
                        }
                        ctx.stroke();
                        ctx.closePath();
                        ctx.restore();
                    }
                    setSource (source: Node) {
                        this.source = source;
                    }
                    setTarget (target: Node) {
                        this.target = target;
                    }
                    // this is used to check is the values given are over the link (mouse events such as hover)
                    contains (m: Object) {
                        return Math.abs((distance(this.source, m, true)+ distance(this.target, m, true)) - distance(this.source, this.target, false)) <= 1;
                    }
                }

                // function is used to see if a link has been clicked on or hovered over
                function distance (a, b, zoom: boolean) {
                    if (zoom) {
                        return Math.sqrt((Math.pow((a.x-((b.x/scale)+translate[0])), 2) + Math.pow((a.y-((b.y/scale)+translate[1])), 2)));
                    }
                    return Math.sqrt((Math.pow((a.x-b.x), 2) + Math.pow((a.y-b.y), 2)));
                }

                // decleration of a new Custom Force
                let customForce = new CustomForce("lateral_map");
                customForce.set_size([lmCtrl.width, lmCtrl.height])
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            ////////////////
            /// NEW DATA ///
            //////////////// -----------------------------------------------------------------------------------------------------------------------------------------------------------
                // Every single node (by IP) recorded on the network (from network assets)
                // the latest lateral connections between two IPs
                lmCtrl.socket.on('lateral_connections', (data) => {
                    if (data === 'done') {
                        load_complete++;
                        lmCtrl.socket.removeListener('lateral_connections');
                        return;
                    }
                    // console.log(data)
                    if (data.rows.length > 0) {
                        new_lat_conns = false;
                        handleLinks(data.rows);
                        if (new_lat_conns) lmCtrl.redraw();
                    }
                })
                lmCtrl.socket.on('lateral_nodes', (data) => {
                    if (data === 'done') {
                        load_complete++;
                        lmCtrl.socket.removeListener('lateral_nodes');
                        return;
                    }
                    // console.log(data)
                    if (data.rows.length > 0) {
                        new_lat_nodes = false;
                        handleNodes(data.rows);
                        if (new_lat_nodes) lmCtrl.redraw();
                    }
                })

                // functions created for the sidebar collapse section
                lmCtrl.newNode = function (newNode: Object) {
                    return new Node(newNode);
                }
                lmCtrl.newLink = function (source: Node, target: Node) {
                    return new Link (source, target)
                }

                // Creates an object with all the L7, proto, service between Resp and orig IPs for quick easy access in the sidebar (do not need to make query like before)
                // Also it the key is all with the resp IP making it easy to tell who is resp & who is orig between the two, and for sending it to the search page
                // TODO: replace all the if exist with just a add to object (if possible)
                function handle_l7(conn) {
                    if (lmCtrl.l7_between_nodes[conn.resp_ip]) {
                        if (lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip]) {
                            if (lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app+conn.proto+conn.service]) {
                                lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app+conn.proto+conn.service].bytes += conn.bytes_orig+conn.bytes_resp
                            } else {
                                lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app+conn.proto+conn.service] = {
                                    l7 : conn.l7_app,
                                    proto : conn.proto,
                                    service : conn.service,
                                    bytes : conn.bytes_orig+conn.bytes_resp,
                                }
                            }
                        } else {
                            lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip] = {}
                            lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app+conn.proto+conn.service] = {
                                l7 : conn.l7_app,
                                proto : conn.proto,
                                service : conn.service,
                                bytes : conn.bytes_orig+conn.bytes_resp,
                            }
                        }
                    } else {
                        lmCtrl.l7_between_nodes[conn.resp_ip] = {};
                        lmCtrl.l7_between_nodes[conn.resp_ip].resp = {
                            [conn.orig_ip] : {
                                [conn.l7_app+conn.proto+conn.service] : {
                                    l7 : conn.l7_app,
                                    proto : conn.proto,
                                    service : conn.service,
                                    bytes : conn.bytes_orig+conn.bytes_resp,
                                }
                            }
                        }
                    }
                }
                // gets the node from network assets, since objects are pass by reference, if node already exists in nodes_object, it is then overriden with the proper values
                // also appends every node to allNodes
                function handleNodes(conn) {
                    let c: number, len: number;
                    for (c = 0, len = conn.length; c < len; c++) {
                        if ((lmCtrl.nodes_object[conn[c].ip]) && (!lmCtrl.nodes_object[conn[c].ip].id)) {
                            lmCtrl.nodes_object[conn[c].ip].editNode(conn[c])
                            lmCtrl.allNodes[conn[c].ip] = lmCtrl.nodes_object[conn[c].ip];
                            new_lat_nodes = true;
                        } else {
                            conn[c].radius = lmCtrl.maxRadius;
                            conn[c].grey = false;
                            conn[c].selected = false;
                            conn[c].visible = true;
                            conn[c].x = lmCtrl.width / 2;
                            conn[c].y = lmCtrl.height / 2;
                            conn[c].px = lmCtrl.width / 2;
                            conn[c].py = lmCtrl.height / 2;
                            conn[c].orig_l7 = [];
                            conn[c].resp_l7 = [];
                            lmCtrl.allNodes[conn[c].ip] = conn[c];
                            // lmCtrl.allNodes[conn[c].ip] = new Node(conn[c]);
                        }
                    }
                }

                /*
                    - This can probably be the most confusing function to follow (good luck)
                    - This function has ALOT of checking to do
                        - So first of, There is 2 calls from the back end simultaneously, one is getting all the nodes possible in the network, while the other is getting the latest lateral connections.
                            - Therefore, a connection can return and the node (connected by IPs) is not yet created, so we have to create a temporary object (or potentially can be a new node in the network).
                                - so we append to the links object the source and target IP of the node (since we are using the IPs for a key in the nodes_object) (only append link if unique)
                            - If a node already exist in allNodes it copies node and is appended to nodes_object. and we still append to the links object the source and target IP of the node. (only append link if unique)
                            - If node does NOT exist in allNodes, a temp node is used until it is overriten. if never overritten, it means that the current IP is not yet recorded in the network assets table and is a new node to
                            the network and will be represented with a '?' icon.
                            - If the node already exists in nodes_object, it checks to see if there is an IOC and appends the l7 applications to the object;
                        - every connection calls handle_l7
                        - Also while doing all of this it has to check for orig_ip and resp_ip and just look at it as Ip basically doing all the above explained twice.
                */
                function handleLinks(conn) {
                    let i: number, len = conn.length;
                    for (i = 0; i < len; i++) {
                        handle_l7(conn[i]);
                        // check if node exists (IP) with the resp_ip, if not created it
                        if (!lmCtrl.nodes_object[conn[i].resp_ip]) {
                            new_lat_conns = true;
                            if (lmCtrl.allNodes[conn[i].resp_ip]) {
                                lmCtrl.allNodes[conn[i].resp_ip].ioc = (Math.max(lmCtrl.allNodes[conn[i].resp_ip].ioc, conn[i].ioc_severity) || 0)
                                lmCtrl.allNodes[conn[i].resp_ip].resp_l7 = _.uniq(_.concat(lmCtrl.allNodes[conn[i].resp_ip].resp_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                                lmCtrl.nodes_object[conn[i].resp_ip] = new Node(lmCtrl.allNodes[conn[i].resp_ip])
                            } else {
                                let newNode = new Node({});
                                newNode.ip = conn[i].resp_ip;
                                newNode.resp_l7 = _.uniq(_.concat(newNode.resp_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                                newNode.ioc = Math.max(newNode.ioc, conn[i].ioc_severity);
                                newNode.first_seen = lmCtrl.main.getTime().end;
                                newNode.last_seen = lmCtrl.main.getTime().end;
                                lmCtrl.nodes_object[conn[i].resp_ip] = new Node(newNode);
                            }
                            lmCtrl.nodes_object[conn[i].resp_ip].connections = [conn[i].orig_ip]
                        } else {
                            lmCtrl.nodes_object[conn[i].resp_ip].ioc = (Math.max(lmCtrl.nodes_object[conn[i].resp_ip].ioc, conn[i].ioc_severity) || 0)
                            lmCtrl.nodes_object[conn[i].resp_ip].resp_l7 = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].resp_ip].resp_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                            lmCtrl.nodes_object[conn[i].resp_ip].connections = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].resp_ip].connections,conn[i].orig_ip))
                        }
                        // check if node exists (IP) with the orig_ip, if not created it
                        if (!lmCtrl.nodes_object[conn[i].orig_ip]) {
                            new_lat_conns = true;
                            if (lmCtrl.allNodes[conn[i].orig_ip]) {
                                lmCtrl.allNodes[conn[i].orig_ip].ioc = (Math.max(lmCtrl.allNodes[conn[i].orig_ip].ioc, conn[i].ioc_severity) || 0)
                                lmCtrl.allNodes[conn[i].orig_ip].orig_l7 = _.uniq(_.concat(lmCtrl.allNodes[conn[i].orig_ip].orig_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                                lmCtrl.nodes_object[conn[i].orig_ip] = new Node(lmCtrl.allNodes[conn[i].orig_ip])
                            } else {
                                let newNode = new Node({});
                                newNode.ip = conn[i].orig_ip;
                                newNode.orig_l7 = _.uniq(_.concat(newNode.orig_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                                newNode.ioc = Math.max(newNode.ioc, conn[i].ioc_severity);
                                newNode.first_seen = lmCtrl.main.getTime().end;
                                newNode.last_seen = lmCtrl.main.getTime().end;
                                lmCtrl.nodes_object[conn[i].orig_ip] = new Node(newNode);
                            }
                            lmCtrl.nodes_object[conn[i].orig_ip].connections = [conn[i].resp_ip]
                        } else {
                            lmCtrl.nodes_object[conn[i].orig_ip].ioc = (Math.max(lmCtrl.nodes_object[conn[i].orig_ip].ioc, conn[i].ioc_severity) || 0)
                            lmCtrl.nodes_object[conn[i].orig_ip].orig_l7 = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].orig_ip].orig_l7,conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service))
                            lmCtrl.nodes_object[conn[i].orig_ip].connections = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].orig_ip].connections,conn[i].resp_ip))
                        }

                        // check if link already exist, if not created it
                        if ((!lmCtrl.allLinks[conn[i].resp_ip+"-"+conn[i].orig_ip]) && (!lmCtrl.allLinks[conn[i].orig_ip+"-"+conn[i].resp_ip])) {
                            new_lat_conns = true;
                            lmCtrl.allLinks[conn[i].resp_ip+"-"+conn[i].orig_ip] = true
                            lmCtrl.links.push(new Link(lmCtrl.nodes_object[conn[i].resp_ip],lmCtrl.nodes_object[conn[i].orig_ip]))
                            // lmCtrl.links.push({source: conn[i].resp_ip,target: conn[i].orig_ip})
                        }
                    }
                }
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            ///////////////////
            /// LATERAL MAP ///
            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
                // initializes the custom force chart, whenever a new node is added it has to "restart" to convert the nodes
                // TODO: make it once it is created you can just add to the list
                lmCtrl.resetInternalMap = function () {
                    lmCtrl.nodes = _.values(lmCtrl.nodes_object)
                    visible_nodes = lmCtrl.nodes.filter((d: Node, i) => d.visible);
                    visible_links = lmCtrl.links.filter((d: Link) => {
                        if (_.isString(d.source) || _.isString(d.target)) return true;
                        return (d.target.visible && d.source.visible)
                    });
                    customForce.set_nodes(visible_nodes);
                    customForce.set_links(visible_links);
                    customForce.start();
                }

                // TODO: look at the way these are both used, can probably combine them
                lmCtrl.redraw = function () {
                    lmCtrl.resetInternalMap();
                }
                lmCtrl.redrawing = function () {
                    lmCtrl.drawSidebar();
                    customForce.resume();
                }

                // // once map is done moving and zooming, it is saved to the local settings
                function zoom_chart_end() {
                    // if wanting to set more than 1 local setting, it seems like you cannot just fire them all at once, you have to wait until the return before the next one is sent
                    lmCtrl.settings.set('translateX', translate[0]).then(function () {
                        return lmCtrl.settings.set('translateY', translate[1])
                    }).then(function () {
                        lmCtrl.settings.set('scale', scale)
                    })
                }
                // called from the sidebar, this function re aligns the map to the center
                lmCtrl.realign_map = function () {
                    customForce.reset_zoom();
                    lmCtrl.waitForFinalEvent(() => {
                        zoom_chart_end();
                    }, 250, "lateral_map_zoom");
                }

                // returns the trasition for the SVGs on the nodes
                function svg_translate(type : string, bigger: number) {
                    let offset: number;
                    switch(type) {
                        case 'connecting':
                        case 'ioc':
                            offset = 18;
                            break;
                        case 'type':
                        case 'group':
                            offset = 17;
                            break;
                        case 'cluster':
                            offset = 16;
                            break;
                        case 'selected':
                            offset = 15;
                            break;
                        case 'Gateway':
                        case 'new':
                            offset = 8.5;
                            break;
                        case 'Printer':
                        case 'Switch':
                        case 'Phone':
                        case 'Web Server':
                            offset = 8;
                            break;
                        case 'Access Point':
                            offset = 7.9;
                            break;
                        case 'Mobile':
                            offset = 7;
                            break;
                        case 'Server':
                        case 'DNS Server':
                        case 'DCHP Server':
                        case 'Laptop':
                        case 'Desktop':
                        case 'Endpoint':
                            offset = 6;
                            break;
                        case 'File Server':
                        case 'Domain Controller':
                            offset = 6.5;
                            break;
                        case 'Database':
                            offset = 5.35;
                            break;
                        default:
                            offset = 7;
                            break;
                    }
                    if (type === "Database") {
                        return [(-offset-((offset/2)*bigger)),(-(offset*1.25)-(((offset*1.25)/2)*bigger))];
                    }
                    return [(-offset-((offset/2)*bigger)),(-offset-((offset/2)*bigger))];
                }

                // returns the trasition for the SVGs on the nodes
                function svg_scale(type : string, bigger: number) {
                    let scale: number;
                    switch(type) {
                        case 'connecting':
                        case 'ioc':
                            scale = 1.5;
                            break;
                        case 'type':
                            scale = 1.45;
                            break;
                        case 'group':
                            scale = 1.4;
                            break;
                        case 'cluster':
                            scale = 1.3;
                            break;
                        case 'selected':
                            scale = 1.25;
                            break;
                        case 'new':
                            scale = 0.7;
                            break;
                        case 'Gateway':
                            scale = 0.66;
                            break;
                        case 'Printer':
                            scale = 0.625;
                            break;
                        case 'Switch':
                            scale = 0.615;
                            break;
                        case 'Phone':
                        case 'Web Server':
                        case 'Access Point':
                            scale = 0.6;
                            break;
                        case 'Mobile':
                        case 'File Server':
                            scale = 0.55;
                            break;
                        case 'Server':
                        case 'DNS Server':
                        case 'DCHP Server':
                        case 'Laptop':
                        case 'Desktop':
                        case 'Endpoint':
                            scale = 0.475;
                            break;
                        case 'Domain Controller':
                            scale = 0.145;
                            break;
                        case 'Database':
                            scale = 0.014;
                            break;
                        default:
                            scale = 0.6;
                            break;
                    }
                    return (scale+((scale/2)*bigger));
                }

                $scope.unselect = function () {
                    unselectAllNodes();
                    lmCtrl.greyOut();
                    $scope.current.node = { type: "N/A", group: "N/A"};
                    lmCtrl.redrawing();
                    lmCtrl.main.clearFilters();
                }
                // When you click on a node this function is called
                // It handles the selected nodes, and shift is pressed, and calls lmCtrl.greyOut
                lmCtrl.nodeClicked = function (node: Node) {
                    let isNodeSelected = node.selected; // need to add this because when we call unselectAllNodes() it does a pass by reference and is always false;
                    lmCtrl.greyOut();
                    if ($scope.selected_nodes.length === 1) {
                        $scope.$apply(function () {
                            $scope.current.node = angular.copy($scope.selected_nodes[0]);
                            if (typeof $scope.current.node.type == 'object') {
                                $scope.current.node.type = "false";
                            }
                            if (typeof $scope.current.node.group == 'object') {
                                $scope.current.node.group = "false";
                            }
                        })
                    } else if ($scope.selected_nodes.length > 1) {
                        $scope.$apply(function () {
                            $scope.current.node.type = "false";
                            $scope.current.node.group = "false";
                        })
                    } else {
                        clearCurrentNode()
                    }
                    lmCtrl.redrawing();
                    lmCtrl.main.clearFilters();
                }

                // returns an array of all the selected and visible nodes
                lmCtrl.getSelectedNodes = function () {
                    return lmCtrl.nodes.filter((d:Node) => (d.selected && d.visible))
                }

                // grey's out all the NONE connecting nodes
                lmCtrl.greyOut = function () {
                    $scope.selected_nodes = lmCtrl.getSelectedNodes();
                    let n = $scope.selected_nodes.length;
                    let selected_ips: string[] = [];
                    while (n--) {
                        if ($scope.selected_nodes[n].collapse) {
                            selected_ips = _.uniq(_.concat(selected_ips,$scope.selected_nodes[n].ip))
                        }
                        if (selected_ips.indexOf($scope.selected_nodes[n].ip) === -1) {
                            selected_ips.push($scope.selected_nodes[n].ip);
                        }
                    }
                    // could do this by nodes_object (either way works)
                    if (selected_ips.length > 0) {
                        lmCtrl.nodes.map((d: Node) => {
                            if (d.collapse) {
                                d.grey = true;
                                let i, len = d.ip.length;
                                for (i = 0; i < len; i++) {    
                                    if (_.intersection(lmCtrl.nodes_object[d.ip[i]].connections, selected_ips).length > 0) {
                                        d.grey = false;
                                    }
                                }
                            } else {
                                d.grey = (!((_.intersection(lmCtrl.nodes_object[d.ip].connections, selected_ips).length > 0) || (selected_ips.includes(d.ip))))
                            }
                        });
                    } else {
                        lmCtrl.nodes.map((d: Node) => d.grey = false);
                    }
                }

                lmCtrl.expand_collapsed = function (node: Node) {
                    let i:number, len = node.ip.length;
                    for (i = 0; i < len; i++) {
                        lmCtrl.nodes_object[node.ip[i]].selected = false;
                        lmCtrl.nodes_object[node.ip[i]].visible = true;
                        lmCtrl.nodes_object[node.ip[i]].grey = false;
                        lmCtrl.nodes_object[node.ip[i]].fixed = false;
                        lmCtrl.already_collapsed_ips = _.remove(lmCtrl.already_collapsed_ips, node.ip[i])
                    }

                    for (let l in lmCtrl.links) {
                        if ((lmCtrl.links[l].source.id == node.id) || (lmCtrl.links[l].target.id == node.id)) {
                            delete lmCtrl.links[l];
                        }
                    }
                    delete lmCtrl.nodes_object[node.id];
                    lmCtrl.redraw();
                }

                // clears the current node type and group in the side bar
                function clearCurrentNode() {
                    $scope.$apply(function () {
                        $scope.current.node = {
                            type: "N/A",
                            group: "N/A"
                        }
                    })
                }
                // Unselected all the nodes
                function unselectAllNodes() {
                    let n:string;
                    for (n in lmCtrl.nodes_object) {
                        lmCtrl.nodes_object[n].selected = false;
                    }
                }
                // this is used to see of the shift key is pressed for multiple selections
                selection().on('keydown', () => {lmCtrl.ctrlKey = event.ctrlKey;}).on('keyup', () => {lmCtrl.ctrlKey = false;}); // Keys recorded in D3, But not in other elements
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            //////////////
            /// SEARCH ///
            ////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
                function filterNodes(filters, node: Node) {
                    let includes = 0;
                    let excludes = true;
                    let n:string, m:string, i:number, e:number,
                    incLen = filters.include.length,
                    excLen = filters.exclude.length;
                    for (i = 0; i < incLen; i++) {
                        for (n in node) {
                            if ((n !== "id") && (n !== "first_seen") && (n !== "last_seen") && (n !== "radius") && (n !== "grey") && (n !== "selected") && (n !== "x") && (n !== "y") && (n !== "connections") && (n !== "weight") && (n !== "px") && (n !== "py") && (n !== "fixed")) {
                                if ((n === "group") && ($scope.groups[node[n]])) {
                                    if (_.includes($scope.groups[node[n]].name.toLowerCase(), filters.include[i].value.toLowerCase())) {   // if want EXACT string match do   -->      if (_.includes(node, filters.include[i].value)) {    <--
                                        includes++;
                                        break;
                                    }
                                } else {
                                    if (_.includes(String(node[n]).toLowerCase(), filters.include[i].value.toLowerCase())) {   // if want EXACT string match do   -->      if (_.includes(node, filters.include[i].value)) {    <--
                                        includes++;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    for (e = 0; e < excLen; e++) {
                        for (m in node) {
                            if ((m !== "id") && (m !== "first_seen") && (m !== "last_seen") && (m !== "radius") && (m !== "grey") && (m !== "selected") && (m !== "x") && (m !== "y") && (m !== "connections") && (m !== "weight") && (m !== "px") && (m !== "py") && (m !== "fixed")) {
                                if ((m === "group") && ($scope.groups[node[m]])) {
                                    if (_.includes($scope.groups[node[m]].name.toLowerCase(), filters.exclude[e].value.toLowerCase())) {   // if want EXACT string match do   -->      if (_.includes(node, filters.exclude[e].value)) {    <--
                                        excludes = false;
                                        break;
                                    }
                                } else {
                                    if (_.includes(String(node[m]).toLowerCase(), filters.exclude[e].value.toLowerCase())) {   // if want EXACT string match do   -->      if (_.includes(node, filters.exclude[e].value)) {    <--
                                        excludes = false;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if ($scope.hide_on_search) {
                        if ((_.includes(lmCtrl.already_collapsed_ips, node.ip)) && (lmCtrl.already_collapsed_ips.length > 0)) {
                            node.visible = false;
                        } else {
                            node.visible = ((includes >= incLen) && excludes)
                        }
                    } else {
                        if ((incLen === 0) && (excLen === 0)) {
                            node.selected = false;
                        } else if ((_.includes(lmCtrl.already_collapsed_ips, node.ip)) && (lmCtrl.already_collapsed_ips.length > 0)) {
                            node.selected = false;
                        } else {
                            node.selected = ((includes >= incLen) && excludes)
                        }
                    }
                    return true;
                }

                $scope.$on('runLatSearch', function (event, filterList) {
                    // if ((filterList.include.length > 0) || (filterList.include.length > 0)) {
                        lmCtrl.nodes.filter(filterNodes.bind(null, filterList));
                        lmCtrl.greyOut()
                        lmCtrl.redraw();
                        lmCtrl.drawSidebar();
                    // }
                })
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            ///////////////////
            /// RESIZE PAGE ///
            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
                function resize_forcechart() {
                    lmCtrl.max_width = element[0].clientWidth, lmCtrl.height = angular.element($window)[0].innerHeight-150;
                    lmCtrl.width = lmCtrl.max_width*0.76;
                    if (select("#sidebar").classed("hide_section")) {
                        lmCtrl.width = lmCtrl.max_width-80;
                    }
                    customForce.clear();
                    customForce.canvas.height = lmCtrl.height;
                    customForce.canvas.width = lmCtrl.width;
                    customForce.resize_zoom();
                    customForce.set_size([lmCtrl.width, lmCtrl.height]);
                    customForce.resume();
                }
                // called from the sidebar directive, when they toggle the hide show sidebar
                lmCtrl.resize_map = function () {
                    resize_forcechart()
                }
                angular.element($window).bind('resize', () => {
                    // Event that happens whenever the window is resized
                    lmCtrl.waitForFinalEvent(() => {
                        resize_forcechart();
                    }, 250, "forcechart_resize");
                });

                select(".sidebar-toggler").on("click", function(){
                    lmCtrl.waitForFinalEvent(() => {
                        resize_forcechart();
                        lmCtrl.resize_sb();
                    }, 100, "forcechart_resize");
                })
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            // clear timers on scope destroy
            $scope.$on('$destroy', function () {
                element = null;
                angular.element($window).unbind('resize');
                customForce.canvas.removeEventListener('selectstart', (e) => { e.preventDefault(); return false; }, false);
                customForce.canvas.removeEventListener('mousedown', (e) => {customForce.mousedown(e);}, false);
                customForce.canvas.removeEventListener('mousemove', (e) => {customForce.mousemove(e);}, false);
                customForce.canvas.removeEventListener('mousewheel', (e) => {customForce.mousewheel(e);}, false);
                customForce.canvas.removeEventListener('mouseup', (e) => {customForce.mouseup(e);}, false);
                customForce.canvas.removeEventListener('dblclick', (e) => {customForce.dblclick(e);}, false);
                if (customForce.timer) {
                    customForce.timer.stop();
                    customForce.timer = null;
                }
                customForce = null;
            });
        }
    };
}

directive.$inject = ['$window', 'timeFormat', '$state', '$stateParams'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/lateralmap/lm_forcechart.ts
 **/